// extracted by mini-css-extract-plugin
export default {"consumption":"Consumption_consumption__VAQUJ"};